import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { intlReducer } from 'react-intl-redux';
import { reducer as formReducer } from 'redux-form';

import account from './accountReducer';
import user from './userReducer';
import subscribe from './subscribeReducer';
import payment from './paymentReducer';
import device from './deviceReducer';
import recaptcha from './recaptchaReducer';

export default history => combineReducers({
  router: connectRouter(history),
  intl: intlReducer,
  form: formReducer,
  account,
  payment,
  subscribe,
  user,
  device,
  recaptcha,
});
